import React, { useState, useEffect } from "react";

function WatchesJewelryForm({ additionalAttributes, setAdditionalAttributes }) {
  const [selectedCategory, setSelectedCategory] = useState("");

  // Debug logging
  useEffect(() => {
    console.log('⌚ WatchesJewelryForm mounted');
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [additionalAttributes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);

    if (name === "category") {
      setSelectedCategory(value);
      
      // ✅ DÜZGÜN: Yeni obyekt yaradıb birbaşa set edirik
      if (value === "Saat") {
        // Saat seçildikdə: category əlavə et, zinyət field-lərini sil
        const { stoneType, karat, weightGrams, ...rest } = additionalAttributes;
        setAdditionalAttributes({
          ...rest,
          category: value
        });
      } else {
        // Zinyət seçildikdə: category əlavə et, saat field-lərini sil
        const { watchType, strapMaterial, mechanismType, hasBox, hasCertificate, ...rest } = additionalAttributes;
        setAdditionalAttributes({
          ...rest,
          category: value
        });
      }
    } else {
      // Digər field-lər üçün
      setAdditionalAttributes({
        ...additionalAttributes,
        [name]: value,
      });
    }
  };

  return (
    <div className="watchesJewelryForm">
      {/* Kateqoriya */}
      <div>
        <h3>
          Kateqoriya <span>*</span>
          <span className="tooltip-icon" title="Məhsul tipi">ℹ️</span>
        </h3>
        <select name="category" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Saat">Saat</option>
          <option value="Üzük">Üzük</option>
          <option value="Boyunbağı">Boyunbağı</option>
          <option value="Sırğa">Sırğa</option>
          <option value="Qolbaq">Qolbaq</option>
          <option value="Broş">Broş</option>
        </select>
      </div>

      {/* Ortaq sahələr */}
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="İstehsalçı">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="brand" 
          placeholder="Rolex, Casio, Cartier..."
          onChange={handleChange} 
          required 
        />
      </div>

      <div>
        <h3>
          Material <span>*</span>
          <span className="tooltip-icon" title="Əsas material">ℹ️</span>
        </h3>
        <select name="material" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Qızıl">Qızıl</option>
          <option value="Gümüş">Gümüş</option>
          <option value="Platin">Platin</option>
          <option value="Bijuteriya">Bijuteriya</option>
          <option value="Dəri">Dəri</option>
          <option value="Paslanmayan Polad">Paslanmayan Polad</option>
        </select>
      </div>

      <div>
        <h3>
          Cins <span>*</span>
          <span className="tooltip-icon" title="Kimin üçün">ℹ️</span>
        </h3>
        <select name="gender" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Kişi">Kişi</option>
          <option value="Qadın">Qadın</option>
          <option value="Uşaq">Uşaq</option>
          <option value="Uniseks">Uniseks</option>
        </select>
      </div>

      <div>
        <h3>
          İstehsal növü <span>*</span>
          <span className="tooltip-icon" title="Əl işi və ya fabrik">ℹ️</span>
        </h3>
        <select name="handmade" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Əl işi">Əl işi</option>
          <option value="Fabrik istehsalı">Fabrik istehsalı</option>
        </select>
      </div>

      <div>
        <h3>
          İstifadə vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Məhsulun vəziyyəti">ℹ️</span>
        </h3>
        <select name="condition" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yeni">Yeni</option>
          <option value="İkinci əl">İkinci əl</option>
        </select>
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Əsas rəng">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Qızılı, Gümüşü, Qara..."
          onChange={handleChange} 
          required 
        />
      </div>

      {/* 🔹 Saat üçün sahələr */}
      {selectedCategory === "Saat" && (
        <>
          <div>
            <h3>
              Saat tipi <span>*</span>
              <span className="tooltip-icon" title="Saat növü">ℹ️</span>
            </h3>
            <select name="watchType" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="Smart">Smart</option>
              <option value="Klassik">Klassik</option>
              <option value="Quartz">Quartz</option>
              <option value="Avtomatik">Avtomatik</option>
              <option value="Mexaniki">Mexaniki</option>
            </select>
          </div>

          <div>
            <h3>
              Kəmər materialı <span>*</span>
              <span className="tooltip-icon" title="Qolbağ materialı">ℹ️</span>
            </h3>
            <select name="strapMaterial" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="Dəri">Dəri</option>
              <option value="Metal">Metal</option>
              <option value="Silikon">Silikon</option>
              <option value="Parça">Parça</option>
            </select>
          </div>

          <div>
            <h3>
              Mexanizm tipi <span>*</span>
              <span className="tooltip-icon" title="Daxili mexanizm">ℹ️</span>
            </h3>
            <select name="mechanismType" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="Quartz">Quartz</option>
              <option value="Automatic">Automatic</option>
              <option value="Manual">Manual</option>
            </select>
          </div>

          <div>
            <h3>
              Qutu <span>*</span>
              <span className="tooltip-icon" title="Orijinal qutu">ℹ️</span>
            </h3>
            <select name="hasBox" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="true">Var ✅</option>
              <option value="false">Yoxdur ❌</option>
            </select>
          </div>

          <div>
            <h3>
              Sertifikat <span>*</span>
              <span className="tooltip-icon" title="Orijinallıq sertifikatı">ℹ️</span>
            </h3>
            <select name="hasCertificate" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="true">Var ✅</option>
              <option value="false">Yoxdur ❌</option>
            </select>
          </div>
        </>
      )}

      {/* 🔸 Zinyət üçün sahələr */}
      {selectedCategory !== "Saat" && selectedCategory !== "" && (
        <>
          <div>
            <h3>
              Daş tipi <span>*</span>
              <span className="tooltip-icon" title="Qiymətli daş">ℹ️</span>
            </h3>
            <select name="stoneType" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="Yoxdur">Yoxdur</option>
              <option value="Brilliant">Brilliant</option>
              <option value="Zümrüd">Zümrüd</option>
              <option value="Sapfir">Sapfir</option>
              <option value="Yaqut">Yaqut</option>
              <option value="Nəqşli daş">Nəqşli daş</option>
            </select>
          </div>

          <div>
            <h3>
              Karat <span>*</span>
              <span className="tooltip-icon" title="Qızıl əyarı">ℹ️</span>
            </h3>
            <select name="karat" onChange={handleChange} defaultValue="" required>
              <option value="" disabled>Seçin</option>
              <option value="14K">14K</option>
              <option value="18K">18K</option>
              <option value="22K">22K</option>
              <option value="24K">24K</option>
            </select>
          </div>

          <div>
            <h3>
              Çəki (qramla) <span>*</span>
              <span className="tooltip-icon" title="Ümumi çəki">ℹ️</span>
            </h3>
            <input 
              type="number" 
              name="weightGrams" 
              min="0.1" 
              step="0.1" 
              placeholder="5.5"
              onChange={handleChange} 
              required
            />
          </div>
        </>
      )}
    </div>
  );
}

export default WatchesJewelryForm;